var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      attrs: { absolute: "", right: "" },
      scopedSlots: _vm._u([
        {
          key: "append",
          fn: function () {
            return [
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", text: "", color: "error" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [_vm._v("cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("save")
                        },
                      },
                    },
                    [_vm._v("save")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.computedValue,
        callback: function ($$v) {
          _vm.computedValue = $$v
        },
        expression: "computedValue",
      },
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.computedValue = false
                          },
                        },
                      },
                      on
                    ),
                    [_c("v-icon", [_vm._v("mdi-chevron-double-right")])],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Close")])]
      ),
      _c(
        "v-card",
        { staticClass: "px-1", attrs: { flat: "" } },
        [
          _c("v-select", {
            staticClass: "mb-2",
            attrs: {
              value: "Node",
              dense: "",
              "hide-details": "",
              items: ["Node"],
              outlined: "",
              readonly: "",
            },
          }),
          _c("NodeForm", {
            model: {
              value: _vm.computedItem,
              callback: function ($$v) {
                _vm.computedItem = $$v
              },
              expression: "computedItem",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }